import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getSmeLoanApplications: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_SME_LOAN_START,
    payload: params,
  }),
  getSmeLoanApplicationsSuccess: (data: any) => ({
    type: actionTypes.GET_SME_LOAN_SUCCESS,
    payload: data,
  }),
  getSmeLoanApplicationsFinish: () => ({
    type: actionTypes.GET_SME_LOAN_FINISH,
  }),
}
